<template>
  <slot v-if="!errorOccurred" />
</template>

<script setup lang="ts">
const errorOccurred = ref(false);
onErrorCaptured((error, instance, info) => {
  errorOccurred.value = true;
  console.error('Error captured in DnErrorBoundary:', error, instance, info);
  return false;
});
</script>
